<template>
  <div>
    <b-overlay :show="loading">
      <b-container fluid>
        <span 
          v-if="zaprosInfo"
          @click="visible = 'zapros'"
          :class="visible === 'zapros' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Запрос на котировку</span>
        <span 
          v-if="obshayaInfo"
          @click="visible = 'obshaya'"
          :class="visible === 'obshaya' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Общая информация</span>
        <span 
          v-if="etapyDvigeniya"
          @click="visible = 'etapy'"
          :class="visible === 'etapy' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Этапы движения</span>
        <span 
          v-if="timelinePostavki"
          @click="visible = 'graph'"
          :class="visible === 'graph' ? 'order-service-menu mx-2 order-service-menu__active':'order-service-menu mx-2'"
        >Таймлайн поставки</span>
      </b-container>

      <div v-show="visible === 'zapros'">
        <b-card>
          <b-container fluid>
            <template v-if="detailedItem.quotation && detailedItem.quotation.data">
                <OrderServiceDeliveryQuotationInfo 
                    :quotation="detailedItem.quotation"
                    :showAnswers="true"
                />
            </template>
            <template v-else>
                <div style="font-style: italic; padding: 25px 15px">Запрос на котировку не составлялся.</div>
            </template>
          </b-container>
        </b-card>
      </div>

      <div v-show="visible === 'obshaya'">
        <b-card>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="6" md="2">
                    <label for="nomer_of_dogovor">Номер договора:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <b-form-input v-model="editedData['0'].value" size="sm" placeholder="" :disabled="true"></b-form-input>
                    <template v-if="editMode && filteredDocs.length > 0">
                      <div class="upDocSelectLinksHead mt-1 font-weight-bold">Выберите договор:</div>
                      <div 
                          v-for="doc in filteredDocs" 
                          @click="changeSelectedDoc(doc)"
                          :key="doc.id"
                          class="docSelectLinks"
                      >
                          {{ doc.name }} ({{ doc.date_of_document | formattedDate }})
                      </div>
                    </template>                                        
                    <template v-if="editMode && filteredDocs.length == 0">
                      <div class="upDocSelectLinksHead mt-1 font-weight-bold">Добавьте в компанию <br />хотя бы один договор ТЭО!</div>
                    </template>
                  </b-col>
                  <b-col sm="6" md="2">
                    <label for="data_of_dogovor">Дата договора:</label>
                  </b-col>
                  <b-col sm="6" md="4">
                    <b-form-input v-model="editedData['1'].value" type="date" size="sm" placeholder="" :disabled="true"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="name_of_cargo">Наименование груза, код ТНВЭД:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['name_of_cargo']" name="name_of_cargo" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="import_export">Импорт / Экспорт:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-select 
                      v-model="editedData['import_export']" 
                      name="import_export" 
                      size="sm" 
                      placeholder="" 
                      :options="[
                        { value: 'Импорт', text: 'Импорт' },
                        { value: 'Экспорт', text: 'Экспорт' }
                      ]"
                      :disabled="!localEditMode"
                    ></b-form-select>
                  </b-col>
                </b-row>                
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="usloviya_postavki_id">Условие поставки:</label>
                  </b-col>
                  <b-col sm="4">
                    <tsoft-select-of-properties
                      :reference_id="68"
                      :needNullElement="true"
                      :disabled="!localEditMode"
                      :selected="editedData['usloviya_postavki_id']"
                      index="usloviya_postavki_id"
                      @set="setReferenceValue"
                    ></tsoft-select-of-properties>  
                  </b-col>
                  <b-col sm="2">
                    <label for="naselenniy_punkt">Населенный пункт:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['naselenniy_punkt']" name="naselenniy_punkt" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="my-2">
              <b-col sm="12" md="6">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="number_of_places">Кол-во мест:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['number_of_places']" type="number" name="number_of_places" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="weight">Вес, кг.:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['weight']" type="number" name="weight" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="volume">Объем, м<sup>3</sup>:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['volume']" type="number" name="volume" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="6">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="platniy_weight">Платный вес, кг.:</label>
                  </b-col>
                  <b-col sm="8">
                    {{ platniy_weight }}
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
          <hr>
          <b-container fluid class="mt-3">
            <b-row class="my-2 mb-3">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="cargo_sender_name">Грузоотправитель:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['cargo_sender_name']" name="cargo_sender_name" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="address_g_o">Адрес ГО:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['address_g_o']" name="address_g_o" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="contact_name_on_shipment">Контактное лицо на погрузке, телефон:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['contact_name_on_shipment']" name="contact_name_on_shipment" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="my-2 mb-3">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="12">
                    <div class="b2c-checkbox-wrap d-flex align-items-center">
                      <b-form-checkbox v-model="b2cCheckbox" :disabled="!localEditMode" @change="onB2cCheckboxChange">
                        B2C
                      </b-form-checkbox>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-if="b2cCheckbox" class="my-2">
                  <b-col sm="2">
                    <label>Партнеры-грузополучатели (B2C):</label>
                  </b-col>
                  <b-col sm="10">
                    <div v-if="cargoRecipientPartnerIds.length > 0" class="mb-2 small">
                      <span class="text-muted">Выбрано: </span>
                      <b-badge v-for="id in cargoRecipientPartnerIds" :key="id" variant="light" class="mr-1">{{ labelForPartnerId(id) }}</b-badge>
                    </div>
                    <div v-if="b2cCompaniesLoading" class="small text-muted">Загрузка...</div>
                    <div v-else-if="b2cCompanies.length === 0" class="small text-muted">Нет компаний с заполненным B2C алиасом.</div>
                    <div v-else class="b2c-companies-list">
                      <div
                        v-for="company in b2cCompanies"
                        :key="company.id"
                        class="b2c-company-item p-2 mb-1 border rounded cursor-pointer"
                        :class="{ 'b2c-company-item-selected': isPartnerSelected(company.id) }"
                        @click="toggleB2cPartner(company)"
                      >
                        <span class="font-weight-bold">{{ company.b2c_alias || company.name }}</span>
                        <span v-if="company.b2c_alias && company.name" class="text-muted small ml-2">— {{ company.name }}</span>
                        <b-icon v-if="isPartnerSelected(company.id)" icon="check-lg" variant="success" class="ml-2"></b-icon>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="cargo_recipient_name">Грузополучатель:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['cargo_recipient_name']" name="cargo_recipient_name" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="inn_g_p">ИНН / КПП:</label>
                  </b-col>
                  <b-col sm="5">
                    <b-form-input v-model="editedData['inn_g_p']" type="number" name="inn_g_p" size="sm" placeholder="ИНН" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="5">
                    <b-form-input v-model="editedData['kpp_g_p']" type="number" name="kpp_g_p" size="sm" placeholder="КПП" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="address_g_p">Адрес ГП:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['address_g_p']" name="address_g_p" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="address_of_unloading">Адрес разгрузки:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['address_of_unloading']" name="address_of_unloading" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="contact_name_on_unloading">Контактное лицо на разгрузке, телефон:</label>
                  </b-col>
                  <b-col sm="10">
                    <b-form-input v-model="editedData['contact_name_on_unloading']" name="contact_name_on_unloading" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="tamogenniy_post_svh_id">Название СВХ:</label>
                  </b-col>
                  <b-col sm="10">
                    <tsoft-select-of-properties
                      :reference_id="5"
                      :needNullElement="true"
                      :needGroups="true"
                      :disabled="!localEditMode"
                      :selected="editedData['tamogenniy_post_svh_id']"
                      index="tamogenniy_post_svh_id"
                      @set="setReferenceValue"
                    ></tsoft-select-of-properties>  
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
          <hr>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="12" md="4">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="aeroport_of_otpravleniya">Аэропорт отправления:</label>
                  </b-col>
                  <b-col sm="8">
                    <tsoft-select-of-airports
                      :selected="editedData['aeroport_of_otpravleniya']"
                      index="aeroport_of_otpravleniya"
                      :need-null-element="true"
                      placeholder="Код или выберите из списка"
                      :disabled="!localEditMode"
                      allow-custom-value
                      @set="setReferenceValue"
                    />
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="aeroport_of_naznacheniya">Аэропорт назначения:</label>
                  </b-col>
                  <b-col sm="8">
                    <tsoft-select-of-airports
                      :selected="editedData['aeroport_of_naznacheniya']"
                      index="aeroport_of_naznacheniya"
                      :need-null-element="true"
                      placeholder="Код или выберите из списка"
                      :disabled="!localEditMode"
                      allow-custom-value
                      @set="setReferenceValue"
                    />
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="tranzitniy_aeroport">Транзитный аэропорт:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['tranzitniy_aeroport']" name="tranzitniy_aeroport" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="nomer_of_awb">№ AWB:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['nomer_of_awb']" name="nomer_of_awb" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="data_vypuska_awb">Дата выпуска AWB / Номер рейса:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['data_vypuska_awb']" name="data_vypuska_awb" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="nomer_reisa">Номер рейса:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['nomer_reisa']" name="nomer_reisa" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="perevozchik_id">Перевозчик:</label>
                  </b-col>
                  <b-col sm="8">
                    <tsoft-select-company
                      :needNullElement="true"
                      :selected="editedData['perevozchik_id']"
                      :disabled="!localEditMode"
                      @set="setCompanyCarrierForAir"
                    ></tsoft-select-company>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="nazvanie_perevozchika">Название перевозчика:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['nazvanie_perevozchika']" name="nazvanie_perevozchika" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="address_perevozchika">Адрес перевозчика:</label>
                  </b-col>
                  <b-col sm="8">
                    <b-form-input v-model="editedData['address_perevozchika']" name="address_perevozchika" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-container>
        </b-card>
      </div>

      <div v-show="visible === 'etapy'">
        <b-card>
          <b-container fluid>
            <b-row class="my-2">
              <b-col sm="12" md="12">
                <b-row class="my-2">
                  <b-col sm="2">
                    <label for="name_of_cargo">Маршрут</label>
                  </b-col>
                  <b-col sm="10">
                    <b-list-group horizontal="md">
                      <b-list-group-item variant="secondary">
                        <span class="small-description">условия поставки</span>
                        {{ nameByPropId(editedData.usloviya_postavki_id) || '<Укажите условия поставки>' }}
                      </b-list-group-item>
                      <b-list-group-item :variant="variantByTwoDays(editedData['pogruzka_plan'], editedData['pogruzka_fact'])">
                        <span class="small-description">адрес погрузки</span>
                        {{ editedData.naselenniy_punkt || '<Укажите населенный пункт>' }}<br>
                        <small>{{ editedData['pogruzka_fact'] || editedData['pogruzka_plan'] || '<Даты нет>' | formattedDate }}</small>
                      </b-list-group-item>
                      <b-list-group-item :variant="variantByTwoDays(editedData['vilet_plan'], editedData['vilet_fact'])">
                        <span class="small-description">аэропорт отправления</span>
                        {{ editedData.aeroport_of_otpravleniya || '<Укажите аэропорт отправления>' }}<br>
                        <small>{{ editedData['vilet_fact'] || editedData['vilet_plan'] || '<Даты нет>' | formattedDate }}</small>
                      </b-list-group-item>
                      <b-list-group-item :variant="variantByTwoDays(editedData['prilet_plan'], editedData['prilet_fact'])">
                        <span class="small-description">аэропорт прибытия</span>
                        {{ editedData.aeroport_of_naznacheniya || '<Укажите аэропорт прибытия>' }}<br>
                        <small>{{ editedData['prilet_fact'] || editedData['prilet_plan'] || '<Даты нет>' | formattedDate }}</small>
                      </b-list-group-item>
                      <b-list-group-item :variant="variantByTwoDays(editedData['dostavka_plan'], editedData['dostavka_fact'])">
                        <span class="small-description">адрес разгрузки</span>
                        {{ editedData.address_of_unloading || '<Укажите адрес разгрузки>' }}<br>
                        <small>{{ editedData['dostavka_fact'] || editedData['dostavka_plan'] || '<Даты нет>' | formattedDate }}</small>
                      </b-list-group-item>
                    </b-list-group>                    
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <hr>
            <b-row class="my-2">
              <b-col sm="12" md="8">
                <b-row class="my-2">
                  <b-col sm="4">
                  </b-col>
                  <b-col sm="4" class="text-center">
                    План
                  </b-col>
                  <b-col sm="4" class="text-center">
                    Факт
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="gotovnost_gruza_plan">Готовность груза:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input 
                        v-model="editedData['gotovnost_gruza_plan']" 
                        name="gotovnost_gruza_plan" 
                        type="date" 
                        size="sm" 
                        placeholder="" 
                        :disabled="!localEditMode"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input 
                        v-model="editedData['gotovnost_gruza_fact']" 
                        name="gotovnost_gruza_fact" 
                        type="date" 
                        size="sm" 
                        placeholder="" 
                        :disabled="!localEditMode"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col class="bg-gray-right">
                        <div class="details-group">
                            <div class="value-of-field">
                              <div class="table-document-correction">
                                <div class="text-uppercase">
                                    <div>
                                        <i v-if="editedData['cargo_sender_name']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['cargo_sender_name']" class="bx bx-x text-danger mr-2"></i>
                                        Грузоотправитель
                                    </div>
                                    <div>
                                        <i v-if="editedData['address_g_o']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['address_g_o']" class="bx bx-x text-danger mr-2"></i>
                                        Адрес ГО
                                    </div>
                                    <div>
                                        <i v-if="editedData['naselenniy_punkt']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['naselenniy_punkt']" class="bx bx-x text-danger mr-2"></i>
                                        Населенный пункт
                                    </div>                                    
                                    <div>
                                        <i v-if="editedData['contact_name_on_shipment']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['contact_name_on_shipment']" class="bx bx-x text-danger mr-2"></i>
                                        Контактное лицо на погрузке
                                    </div>
                                    <div>
                                        <i v-if="editedData['cargo_recipient_name'] && editedData['inn_g_p']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['cargo_recipient_name'] && !editedData['inn_g_p']" class="bx bx-x text-danger mr-2"></i>
                                        Грузополучатель
                                    </div>
                                    <div>
                                        <i v-if="editedData['address_g_p']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['address_g_p']" class="bx bx-x text-danger mr-2"></i>
                                        Адрес ГП
                                    </div>
                                    <div>
                                        <i v-if="editedData['address_of_unloading']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['address_of_unloading']" class="bx bx-x text-danger mr-2"></i>
                                        Адрес разгрузки
                                    </div>
                                    <div>
                                        <i v-if="editedData['contact_name_on_unloading']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['contact_name_on_unloading']" class="bx bx-x text-danger mr-2"></i>
                                        Контактное лицо на разгрузке
                                    </div>
                                    <div>
                                        <i v-if="editedData['nazvanie_perevozchika']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['nazvanie_perevozchika']" class="bx bx-x text-danger mr-2"></i>
                                        Название перевозчика
                                    </div>
                                    <div>
                                        <i v-if="editedData['address_perevozchika']" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!editedData['address_perevozchika']" class="bx bx-x text-danger mr-2"></i>
                                        Адрес перевозчика
                                    </div>
                                    <div>
                                        <i v-if="hasDocumentWithId339" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!hasDocumentWithId339" class="bx bx-x text-danger mr-2"></i>
                                        В документах «Заявка на перевозку»
                                    </div>
                                </div>
                              </div>
                            </div>
                            <div class="descr-of-field">Для проставления готовности груза, заполните поля, добавьте документы.</div>
                        </div>
                    </b-col>
                </b-row>

                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="pogruzka_plan">Погрузка:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input 
                        v-model="editedData['pogruzka_plan']" 
                        name="pogruzka_plan" 
                        type="date" 
                        size="sm" 
                        placeholder="" 
                        :disabled="!localEditMode"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input 
                        v-model="editedData['pogruzka_fact']" 
                        name="pogruzka_fact" 
                        type="date" 
                        size="sm" 
                        placeholder="" 
                        :disabled="!localEditMode"
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col class="bg-gray-right">
                        <div class="details-group">
                            <div class="value-of-field">
                              <div class="table-document-correction">
                                <div class="text-uppercase">
                                    <div>
                                        <i v-if="hasDocumentWithId339" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!hasDocumentWithId339" class="bx bx-x text-danger mr-2"></i>
                                        Заявка на перевозку
                                    </div>
                                    <div>
                                        <i v-if="hasDocumentWithId353" class="bx bx-check text-success mr-2"></i>
                                        <i v-if="!hasDocumentWithId353" class="bx bx-x text-danger mr-2"></i>
                                        Страховой полис
                                    </div>
                                </div>
                              </div>
                            </div>
                            <div class="descr-of-field">Для проставления погрузки, добавьте документы.</div>
                        </div>
                    </b-col>
                </b-row>

                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="vilet_plan">Вылет:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['vilet_plan']" name="vilet_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['vilet_fact']" name="vilet_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="prilet_plan">Прилет:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['prilet_plan']" name="prilet_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['prilet_fact']" name="prilet_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4" class="text-center">
                <label>Транзитное время:</label>
                <div>{{ editedData['naselenniy_punkt'] || '<Укажите населенный пункт>' }} - {{ editedData['aeroport_of_naznacheniya'] || '<Укажите аэропорт назначения>' }}</div>
                <div class="bigNumber">{{ transitnoe_vremya }}</div>
              </b-col>
            </b-row>
            <b-row class="my-2">
              <b-col sm="12" md="8">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="zakritie_dostavki_plan">Закрытие доставки:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['zakritie_dostavki_plan']" name="zakritie_dostavki_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['zakritie_dostavki_fact']" name="zakritie_dostavki_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="podacha_dt_plan">Подача ДТ:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['podacha_dt_plan']" name="podacha_dt_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['podacha_dt_fact']" name="podacha_dt_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="vypusk_dt_plan">Выпуск ДТ:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['vypusk_dt_plan']" name="vypusk_dt_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['vypusk_dt_fact']" name="vypusk_dt_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4" class="text-center">
                <label>Время ТО:</label>
                <div class="bigNumber">{{ time_of_to }}</div>
              </b-col>
            </b-row>

            <b-row class="my-2">
              <b-col sm="12" md="8">
                <b-row class="my-2">
                  <b-col sm="4">
                    <label for="dostavka_plan">Доставка до склада клиента:</label>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['dostavka_plan']" name="dostavka_plan" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                  <b-col sm="4">
                    <b-form-input v-model="editedData['dostavka_fact']" name="dostavka_fact" type="date" size="sm" placeholder="" :disabled="!localEditMode"></b-form-input>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="12" md="4" class="text-center"></b-col>
            </b-row>

            <hr>
            <b-row class="my-2">
              <b-col sm="12" class="text-center">
                <div class="bigNumber transitItogBlock">Общее транзитное время: {{ obshee_transitnoe_vremya }}</div>
              </b-col>
            </b-row>

          </b-container>
          
        </b-card>
      </div>

      <ActiveHistory
        v-if="visible === 'graph'"
        :serviceIds="detailedItem.id"
      />
    </b-overlay>
  </div>
</template>

<script>
import OrderServiceDeliveryQuotationInfo from '@/components/orders/orderServiceQuotation/OrderServiceDeliveryQuotationInfo.vue';
import ActiveHistory from '@/components/orders/orderServiceTemplate/v2/ActiveHistory';
import { API_COMPANY } from '@/constants';
import {
  constantsAllReferenceProperties,
  dateHelpers,
  dataHelpers
} from '@/mixins';

export default {
  props: {
    editMode: {
      type: Boolean,
      default: false,
    },
    saveMode: {
      type: Boolean,
      default: false,
    },
    detailedItem: {
      type: Object,
      required: true,
    },
    filteredDocs: {
      type: Array,
      required: true,
    },
    zaprosInfo: {
      type: Boolean,
      default: true,
    },
    obshayaInfo: {
      type: Boolean,
      default: true,
    },
    etapyDvigeniya: {
      type: Boolean,
      default: true,
    },
    timelinePostavki: {
      type: Boolean,
      default: true,
    },
    defaultVisible: {
      type: String,
      default: 'obshaya',
    },
  },
  mixins: [
    constantsAllReferenceProperties,
    dateHelpers,
    dataHelpers
  ],
  components: {ActiveHistory, OrderServiceDeliveryQuotationInfo},
  data() {
    return {
      loading: false,
      localEditMode: false,
      visible: 'obshaya',
      b2cCheckbox: false,
      b2cCompanies: [],
      b2cCompaniesLoading: false,
      editedData: {
        "0": { value: '' },
        "1": { value: '' },
        name_of_cargo: '',
        import_export: 'Импорт',
        usloviya_postavki_id: null,
        naselenniy_punkt: '',
        number_of_places: 0,
        weight: 0,
        volume: 0,
        platniy_weight: 0,
        cargo_sender_name: '',
        address_g_o: '',
        contact_name_on_shipment: '',
        cargo_recipient_name: '',
        inn_g_p: '',
        kpp_g_p: '',
        address_g_p: '',
        address_of_unloading: '',
        contact_name_on_unloading: '',
        tamogenniy_post_svh_id: null,
        /** Сохраняется в услугу: для выгрузки Excel (B2C + партнёры → строки по карточкам компаний) */
        b2c_recipient_mode: false,
        cargo_recipient_partner_ids: [],

        aeroport_of_otpravleniya: '',
        aeroport_of_naznacheniya: '',
        tranzitniy_aeroport: '',
        nomer_of_awb: '',
        nomer_reisa: '',
        data_vypuska_awb: '',
        perevozchik_id: null,
        nazvanie_perevozchika: '',
        address_perevozchika: '',

        gotovnost_gruza_plan: '',
        gotovnost_gruza_fact: '',
        pogruzka_plan: '',
        pogruzka_fact: '',
        vilet_plan: '',
        vilet_fact: '',
        prilet_plan: '',
        prilet_fact: '', 

        transitnoe_vremya: '',

        zakritie_dostavki_plan: '',
        zakritie_dostavki_fact: '',
        podacha_dt_plan: '',
        podacha_dt_fact: '',
        vypusk_dt_plan: '',
        vypusk_dt_fact: '',
        time_of_to: '',

        dostavka_plan: '',
        dostavka_fact: '',
        obshee_transitnoe_vremya: ''
      },
    };
  },
  watch: {
    editMode: {
      handler(value) {
        this.localEditMode = value;
      },
      immediate: true
    },
    saveMode: {
      handler(value) {
        if (value == true) {
          this.$emit('updateData', this.editedData);
        }
      },
      immediate: true
    },
    detailedItem: {
      handler(data) {
        this.editedData = this.deepMergeSafeFirst(JSON.parse(JSON.stringify(data.data)), JSON.parse(JSON.stringify(this.editedData)));
        this.normalizeCargoRecipientPartnerIds();
        if (this.editedData.cargo_recipient_partner_ids && this.editedData.cargo_recipient_partner_ids.length > 0) {
          this.b2cCheckbox = true;
          this.loadB2cCompanies();
        }
        if (this.editedData.b2c_recipient_mode) {
          this.b2cCheckbox = true;
          if (!this.b2cCompanies.length) {
            this.loadB2cCompanies();
          }
        }
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    cargoRecipientPartnerIds() {
      const v = this.editedData.cargo_recipient_partner_ids;
      if (Array.isArray(v)) return v;
      if (typeof v === 'string' && v) return v.split(',').map(id => parseInt(id, 10)).filter(id => !isNaN(id));
      return [];
    },
    transitnoe_vremya() {
      if (!this.editedData['prilet_fact'] || !this.editedData['pogruzka_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['pogruzka_fact'], this.editedData['prilet_fact']);
      return transitnoe_vremya;      
    },
    time_of_to() {
      if (!this.editedData['vypusk_dt_fact'] || !this.editedData['podacha_dt_fact']) {
        // return 'Заполните поля <Выпуск ДТ> и <Подача ДТ>';
        return "<Расчет недоступен>";
      } 

      const time_of_to = this.getDiffNumberOfDays(this.editedData['podacha_dt_fact'], this.editedData['vypusk_dt_fact']);
      return time_of_to;
    },
    obshee_transitnoe_vremya() {
      if (!this.editedData['pogruzka_fact'] || !this.editedData['dostavka_fact']) {
        return '<Расчет недоступен>';
      } 

      const transitnoe_vremya = this.getDiffNumberOfDays(this.editedData['pogruzka_fact'], this.editedData['dostavka_fact']);
      return transitnoe_vremya;      
    },
    platniy_weight() {
      if (!this.editedData['weight'] || !this.editedData['volume']) {
        return '<Расчет недоступен>';
      } 

      let tempWeight = this.editedData['volume'] * 167;

      if (tempWeight < this.editedData['weight']) {
        return this.editedData['weight'];
      }
        
      return tempWeight;
    },
    hasDocumentWithId339() {
        const hasDocumentWithId339 = this.detailedItem.documents && 
            this.detailedItem.documents.some(document => document.reference_document_type_id === 339);

        return hasDocumentWithId339;
    },
    hasDocumentWithId353() {
        const hasDocumentWithId353 = this.detailedItem.documents && 
            this.detailedItem.documents.some(document => document.reference_document_type_id === 353);

        return hasDocumentWithId353;
    },
    isCanFillGotovnostGruza() {
        return true;
    }
  },
  methods: {
    setReferenceValue(value, reference_id, index) {
      this.editedData[index] = value;
    },
    /** Как грузополучатель в FTL: поиск компании → наименование и адрес перевозчика */
    setCompanyCarrierForAir(value, element) {
      this.editedData['perevozchik_id'] = value === '' || value === null || value === undefined ? null : value;
      if (element && typeof element === 'object' && element.name !== undefined) {
        this.editedData['nazvanie_perevozchika'] = element.name || '';
        this.editedData['address_perevozchika'] = element.address != null ? String(element.address) : '';
      }
    },
    changeSelectedDoc(doc) {
      this.editedData[0].value = doc.name;
      this.editedData[1].value = doc.date_of_document;
    },
    onB2cCheckboxChange(checked) {
      this.$set(this.editedData, 'b2c_recipient_mode', !!checked);
      if (checked) {
        this.loadB2cCompanies();
      } else {
        this.b2cCompanies = [];
        this.$set(this.editedData, 'cargo_recipient_partner_ids', []);
      }
    },
    loadB2cCompanies() {
      this.b2cCompaniesLoading = true;
      this.b2cCompanies = [];
      api.call('get', `${API_COMPANY}?b2c_list_with_alias=1&per_page=200`)
        .then(({ data }) => {
          const list = Array.isArray(data) ? data : (data.data || []);
          this.b2cCompanies = Array.isArray(list) ? list : [];
        })
        .catch(() => {
          this.b2cCompanies = [];
        })
        .finally(() => {
          this.b2cCompaniesLoading = false;
        });
    },
    normalizeCargoRecipientPartnerIds() {
      const v = this.editedData.cargo_recipient_partner_ids;
      if (Array.isArray(v)) return;
      const arr = (typeof v === 'string' && v ? v.split(',') : []).map(id => parseInt(String(id).trim(), 10)).filter(id => !isNaN(id));
      this.$set(this.editedData, 'cargo_recipient_partner_ids', arr);
    },
    isPartnerSelected(companyId) {
      return this.cargoRecipientPartnerIds.indexOf(companyId) !== -1;
    },
    labelForPartnerId(id) {
      const c = this.b2cCompanies.find(co => co.id === id);
      return c ? (c.b2c_alias || c.name) : `#${id}`;
    },
    toggleB2cPartner(company) {
      const ids = [...this.cargoRecipientPartnerIds];
      const i = ids.indexOf(company.id);
      if (i === -1) ids.push(company.id);
      else ids.splice(i, 1);
      this.$set(this.editedData, 'cargo_recipient_partner_ids', ids);
      if (ids.length > 0) {
        this.$set(this.editedData, 'b2c_recipient_mode', true);
        this.b2cCheckbox = true;
      }
    },
  },
  mounted() {
    this.visible = this.defaultVisible;
  },
};
</script>
<style scoped>
.custom-select {
  height: 34px !important;
  border-radius: 3px !important;
  padding: 1px 8px;
}
.small-description {
  line-height: 11px;
}
.b2c-checkbox-wrap >>> .custom-control {
  display: flex;
  align-items: center;
  min-height: 1.25rem;
}
.b2c-checkbox-wrap >>> .custom-control-label {
  line-height: 1.4rem;
  padding-top: 0;
  padding-bottom: 0;
  display: inline-flex;
  align-items: center;
}
.b2c-checkbox-wrap >>> .custom-control-input {
  margin-top: 0;
}
.b2c-company-item:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.b2c-company-item-selected {
  background-color: rgba(0, 123, 255, 0.1);
  border-color: #007bff;
}
.cursor-pointer {
  cursor: pointer;
}
</style>